export const GET_BOT_CONFIG_LIST = "yourbots/GET_BOT_CONFIG_LIST"
export const SET_BOT_CONFIG_LIST = "yourbots/SET_BOT_CONFIG_LIST"